import { useState } from "react";
import { useAdminStore, useForm } from "../../../hooks";
import { InputForm, LoadingData, ErrorMessage, SuccessMessage } from "../../ui";
import { useFormMessages } from "../../hooks";

const formData = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const formValidations = {
  oldPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  newPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  confirmPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
};

export const EditSecretaryPassword = () => {
  // Datos del hook ----------------------------------------//
  const {
    //props
    isLoading,
    message,

    // Methods
    startUpdatePassword,
  } = useAdminStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
    onResetForm,
  });

  const { oldPassword, newPassword, confirmPassword } = formState;

  const { oldPasswordValid, newPasswordValid, confirmPasswordValid } =
    formValidation;

  // Funciones ---------------------------------------------//

  const onUpdatePassword = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdatePassword(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <div className="rounded shadow mt-4">
      <div className="p-4 border-bottom">
        <h6 className="mb-0">Actualiza tu contraseña:</h6>
      </div>
      <div className="p-4">
        <form onSubmit={onUpdatePassword}>
          <div className="row g-3">
            {/* Formulario estatico */}
            <>
              <div className="col-lg-12">
                <InputForm
                  label={"Contraseña actual"}
                  sublabel={"Minimo 8 caracteres"}
                  type={"password"}
                  placeholder={"Contraseña"}
                  validation={oldPasswordValid}
                  submit={validateForm}
                  name={"oldPassword"}
                  value={oldPassword}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-lg-12">
                <InputForm
                  label={"Nueva contraseña"}
                  sublabel={"Minimo 8 caracteres"}
                  type={"password"}
                  placeholder={"Nueva contraseña"}
                  validation={newPasswordValid}
                  submit={validateForm}
                  name={"newPassword"}
                  value={newPassword}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-lg-12">
                <InputForm
                  label={"Confirmar contraseña"}
                  sublabel={"Minimo 8 caracteres"}
                  type={"password"}
                  placeholder={"Confirmar contraseña"}
                  validation={confirmPasswordValid}
                  submit={validateForm}
                  name={"confirmPassword"}
                  value={confirmPassword}
                  onInputChange={onInputChange}
                />
              </div>
            </>

            {/* Mensajes */}
            <>
              {isLoading && (
                <div className="col-md-12">
                  <LoadingData />
                </div>
              )}
              {showErrorMessage && (
                <div className="col-md-12">
                  <ErrorMessage>{messageText}</ErrorMessage>
                </div>
              )}
              {showSuccessMessage && (
                <div className="col-md-12">
                  <SuccessMessage>{messageText}</SuccessMessage>
                </div>
              )}
            </>

            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                Actualizar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
